<template>
  <div>
    <!-- page-wrapper Start-->
    <div class="container-fluid p-0">
      <div class="row m-0">
        <div class="col-12 p-0">
          <div class="login-card">
            <div>
              <div class="text-center pb-2" style="margin-top:-55px">
                <a class="logo mb-1 mt-1" >
                  <img
                    style="width:80px"
                    class="img-fluid for-light"
                    src="../assets/images/logo/gs.png"
                    alt="looginpage"
                  />
                  <img
                    style="width:80px"
                    class="img-fluid for-dark"
                    src="../assets/images/logo/gs.png"
                    alt="looginpage"
                  />
                </a>
                <h2 class="txt- f-w-600">Shopnscan  
                  <!-- <small class="text-muted f-w-500" style="font-size: 1.1rem;color: #a0a0a0 !important;">Admin</small>  -->
                  
                  
                  </h2>
              </div>
              <div class="login-main login-form-card">

                <div class="media">
                        <label class="col-form-label m-r-10">{{ Type }} login</label>
                        <div v-if="!production" class="media-body text-right">
                          <label class="switch">
                            <input type="checkbox" v-model="isAdmin"><span class="switch-state"></span>
                          </label>
                        </div>
                      </div>

                        <b-alert v-if="loginResponse.message" show variant="secondary" :class="`alert ${loginResponse.type} `">
                          <p>{{ loginResponse.message }}</p>
                        </b-alert>
                
                        <form class="theme-form" @submit.stop.prevent="handleSubmit" >
                          <h4>Sign in to account</h4>
                          <p>Enter your email & password to login</p>
                          <div class="form-group">
                            <label class="col-form-label">Email Address</label>
                            <input
                              v-model="email"
                              class="form-control"
                              type="email"
                              required=""
                              placeholder="Test@gmail.com"
                              :class="{
                                'is-invalid': submitted && !email,
                              }"
                            />
                            <div
                              v-show="submitted && !email"
                              class="invalid-feedback"
                            >
                              Email is required
                            </div>
                          </div>
                          <div class="form-group">
                            <label class="col-form-label">Password</label>
                            <input
                              v-model="password"
                              autocomplete=""
                              class="form-control"
                              :type="type"
                              name="login[password]"
                              required=""
                              placeholder="*********"
                              :class="{
                                'is-invalid': submitted && !email,
                              }"
                            />
                            <div
                              v-show="submitted && !password"
                              class="invalid-feedback"
                            >
                              Email is required
                            </div>
                            <div class="show-hide" @click="showPassword">
                              <span class="show"></span>
                            </div>
                          </div>
                          <div class="form-group mb-0">
                            <div class="checkbox p-0">
                              <input id="checkbox1" v-model="remember" type="checkbox" />
                              <label class="text-muted" for="checkbox1"
                                >Remember password</label
                              >
                            </div>
                            <button
                              class="btn btn-primary btn-block"
                              type="submit"
                              :disabled="loggingIn"
                            >
                              Login
                            </button>
                          </div>
                          
                          <p class="mt-4 mb-0">
                            <!-- Don't have account?
                            <router-link class="ml-2" tag="a" to="/auth/register" >
                            Create Account
                          </router-link> -->
                          </p>
                        </form>

                        
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- latest jquery-->
  </div>
</template>

<script>
import axios from "axios"
import router from '../router/index'
import Userauth from '../auth/js/index'

export default {
  name: "login",
  data() {
    return {
      type: "password",
      isAdmin: false,
      Type: "Shop",
      remember: true,
      email: "",
      password: "",
      username: "test",
      passwordjwt: "lol",
      submitted: false,
      production: null,
    };
  },
  computed: {
    // JWT authentication
    loggingIn() {
      return this.$store.state.authentication.status.loggingIn;
    },
    loginResponse() {
      return this.$store.state.alert;
    }
  },
  watch: {
    isAdmin(){
     
      Userauth.isAdmin(this.isAdmin)
      
      if (this.isAdmin) {
        this.Type = "Admin"
      } else {
        this.Type = "Shop"
      }
      
      //
      this.$store.dispatch('menu/checkIsAdmin', this.isAdmin)
    }
  },
  created() {
    
    if (this.$store.state.authentication.status.loggedIn) {
      // Go to page dashboard if logged
      return router.push("/");
    }

    this.isAdmin = localStorage.getItem('type') == 'admin' ? true : false

    this.production = window.location.host.includes('.shopnscan.app')

    // reset login status for JWT
    // this.$store.dispatch("authentication/logout");
  },
  methods: {
    // JWT authentication
    handleSubmit() {
      this.submitted = true;
      const { email, password, remember } = this;
      const { dispatch } = this.$store;
      if (email && password) {
         dispatch("authentication/login", { email, password, remember })
        
      }
      // console.log(e)
      
    },
    // show/hide password
    showPassword: function () {
      if (this.type === "password") {
        this.type = "text";
      } else {
        this.type = "password";
      }
    },
    // Firebase login
    signIn: function () {
      this.submitted = true;

      axios.post('/login', { email: this.email, password: this.password, remember: this.remember })
          .then(
            (result) => {
              // Userauth.localLogin(result.data.user);
              
              this.$swal({
                title:"Welcome !",
                text: result.data.message,
                type:'success'
              });

              this.$router.replace("/");

            })
            .catch(
            (err) => {
              // (this.email = "test@admin.com"), (this.password = "test@123456");
              this.$swal({
                title:"Failed!",
                text: err.response.data,
                type:'error'
              });
            }
          );
    }
  },
};
</script>
<style lang="scss">
  .login-main {
    margin-top: 10px !important;
  }
</style>